var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDumbbell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 68,
    viewBox: "0 0 184 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 5C34 2.23858 36.2386 0 39 0H52C54.7614 0 57 2.23858 57 5V63C57 65.7614 54.7614 68 52 68H39C36.2386 68 34 65.7614 34 63V5Z",
    fill: "var(--icon-color)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 41C58.8954 41 58 40.1046 58 39V28C58 26.8954 58.8954 26 60 26H124C125.105 26 126 26.8954 126 28V39C126 40.1046 125.105 41 124 41H60Z",
    fill: "var(--icon-color)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15C17 12.2386 19.2386 10 22 10H28C30.7614 10 33 12.2386 33 15V53C33 55.7614 30.7614 58 28 58H22C19.2386 58 17 55.7614 17 53V15Z",
    fill: "var(--icon-color)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M150 5C150 2.23858 147.761 0 145 0H132C129.239 0 127 2.23858 127 5V63C127 65.7614 129.239 68 132 68H145C147.761 68 150 65.7614 150 63V5Z",
    fill: "var(--icon-color)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M167 15C167 12.2386 164.761 10 162 10H156C153.239 10 151 12.2386 151 15V53C151 55.7614 153.239 58 156 58H162C164.761 58 167 55.7614 167 53V15Z",
    fill: "var(--icon-color)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M184 30C184 27.2386 181.761 25 179 25H173C170.239 25 168 27.2386 168 30V36C168 38.7614 170.239 41 173 41H179C181.761 41 184 38.7614 184 36V30Z",
    fill: "var(--icon-color)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16 30C16 27.2386 13.7614 25 11 25H5C2.23858 25 0 27.2386 0 30V36C0 38.7614 2.23858 41 5 41H11C13.7614 41 16 38.7614 16 36V30Z",
    fill: "var(--icon-color)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDumbbell);
export default __webpack_public_path__ + "static/media/dumbbell.e3914045371a8441379b1c318297c9e2.svg";
export { ForwardRef as ReactComponent };